import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

import { useBannerSize } from '../../../../common/hooks/use-banner-size';

export function OfflineBannerContent() {
  const { h, fontSize } = useBannerSize();
  return (
    <Flex align="center" w="100%" h={h}>
      <Box flex={1} textAlign="center" pr={2} borderRadius="md">
        <Text fontSize={fontSize} letterSpacing="wider">
          OFFLINE
        </Text>
        <Text fontSize="sm">Wi-Fi</Text>
      </Box>
    </Flex>
  );
}
